import { render, staticRenderFns } from "./Procedimento.vue?vue&type=template&id=c1704410&"
import script from "./Procedimento.vue?vue&type=script&lang=js&"
export * from "./Procedimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports